import { inject, injectable } from 'inversify';
import { action, observable } from 'mobx';
import { CourseApi } from '../api/CourseApi';
import { STORAGE_CURRENT_COURSE_NAME } from '../constants/base.constants';
import { CourseModel } from '../interfaces/models/CourseModel';
import { ILocalStorageAdapter, LocalStorageSymbol } from './adapters/ILocalStorageAdapter';

@injectable()
export class CourseStore {

    @observable coursesList: CourseModel[] = [];
    @observable currentCourse: CourseModel;

    constructor(
        private courseApi: CourseApi,
        @inject(LocalStorageSymbol) private localStorageAdapter: ILocalStorageAdapter,
    ) {}

    @action.bound setCourse(id) {
        const index = this.coursesList.findIndex(i => i.id === Number(id));

        this.currentCourse = this.coursesList[ index ];
        this.localStorageAdapter.write(STORAGE_CURRENT_COURSE_NAME, id.toString());
    }

    @action.bound async setCurrentCourse() {
        const id = await this.localStorageAdapter.read(STORAGE_CURRENT_COURSE_NAME);

        if (id && this.coursesList.findIndex(i => i.id === Number(id)) > -1) {
            this.setCourse(id);
        } else {
            // const availableCourses = this.coursesList.filter(course => course.is_available);

            const availableCourses = this.coursesList;

            if (availableCourses.length) {
                this.setCourse(availableCourses[ 0 ].id);
            }
        }
    }

    /**
     * Load courses list
     *
     * @param preview set true to load courses even if user is unauthorized
     */
    @action.bound async loadCoursesList(preview = false) {
        const courses = await (
            preview ? this.courseApi.getCourses() : this.courseApi.getAvailableCourses()
        );
        this.coursesList = courses.data;
    }

    async getCourseSize(id: number): Promise<{ size: number; items: number }> {
        const result = await this.courseApi.getCourseSize(id);

        return result.data;
    }

}
